const initialState = {
  error: null,
  status: null,
  selectedImage: null,
  selectedRender: [],
  selectedSketch: [],
  images: [],
  imageVersions: {},
  shader: "classic",
  shaderTutorialToggle: false,
  onyxImageSampleExists: false,
};

const s2rReducer = (state = initialState, action) => {
  switch (action.type) {
    case "s2r/imageClicked":
      return {
        ...state,
        selectedImage: action.image,
      };

    case "s2r/renderSelected":
      return {
        ...state,
        selectedRender: action.image,
      };

    case "s2r/sketchSelected":
      return {
        ...state,
        selectedSketch: action.image,
      };

    // object { id: [{image1.1},{image1.2}], id: [{image2.1},{image2.2}] }
    case "s2r/imageAdded":
      return {
        ...state,
        imageVersions: Object.defineProperty(
          state.imageVersions,
          action.image.id,
          {
            value: [action.image],
            writable: true,
            configurable: true,
            enumerable: true,
          }
        ),
      };

    case "s2r/imageEdited":
      return {
        ...state,
        imageVersions: {
          ...state.imageVersions,
          [action.image.id]: [
            ...state.imageVersions[action.image.id],
            action.image,
          ],
        },
      };

    case "s2r/undo":
      return {
        ...state,
        imageVersions: {
          ...state.imageVersions,
          [action.image?.id]:
            state.imageVersions[action.image?.id].length === 1
              ? state.imageVersions[action.image?.id]
              : state.imageVersions[action.image?.id]?.slice(
                  0,
                  state.imageVersions[action.image.id]?.length - 1
                ),
        },
      };

    case "s2r/shaderOptionChanged":
      return {
        ...state,
        shader: action.shader,
      };

    case "s2r/updateLevels":
      return {
        ...state,
        imageVersion: action.imageVersion,
      };

    case "s2r/renderImageStarted":
      return {
        ...state,
        status: "loading",
        error: null,
      };

    case "s2r/renderImageFinished":
      return {
        ...state,
        status: null,
        error: null,
        imageVersions: Object.defineProperty(
          state.imageVersions,
          action.image.id,
          {
            value: [action.image],
            writable: true,
            configurable: true,
            enumerable: true,
          }
        ),
      };

    case "s2r/renderImageError":
      return {
        ...state,
        status: null,
        error: action.error,
      };

    case "s2r/shaderTutorialToggled":
      return {
        ...state,
        shaderTutorialToggle: action.option,
      };
    case "s2r/contactOpen":
      return {
        ...state,
        contactOpen: action.option,
      };

    case "s2r/onyxImageSampleExists":
      return {
        ...state,
        onyxImageSampleExists: action.option,
      };

    default:
      return state;
  }
};
export default s2rReducer;
